import { useCallback } from 'react';
import { buildFileUploadData } from '../utils/file-upload';
import { useFileSession } from '../contexts/FileSessionContext';
import { useNotifications } from '../components/notifications/NotificationProvider';
import { showUnmatchedEventFilesNotificationIfNeeded } from './upload-notifications';

/**
 * Upload tail shared by the file-picking buttons. Deliberately does not catch:
 * each caller reports errors differently and owns resetting its file input.
 */
export function useFileUpload(): (files: File[]) => Promise<void> {
  const { onUploadFiles } = useFileSession();
  const notifications = useNotifications();

  return useCallback(
    async (files: File[]) => {
      const data = await buildFileUploadData(files);
      showUnmatchedEventFilesNotificationIfNeeded(notifications, data);
      await onUploadFiles(data);
    },
    [notifications, onUploadFiles],
  );
}
